export function getBlankRecord() {
  return {
    id: null,
    category: null,
    providerName: null,
    providerId: null,
    administrativeFeeOverrideType: null,
    riskPremiumOverrideType: null,
    specialTuitionProtectionOverrideType: null,
    administrativeFeeComponent: null,
    administrativeFeeComponentDescription: null,
    riskRatedPremiumComponent: null,
    riskRatedPremiumComponentDescription: null,
    specialTuitionProtectionComponent: null,
    specialTuitionProtectionComponentDescription: null,
    invoiceAddressee: null,
    explanation: null,
    description: null
  };
}
